import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { demandsMutations } from '../../../graphql/mutations'
import { demandsQueries, walletQueries } from '../../../graphql/queries'
import Modal from '@mui/material/Modal'
import graphqlHelpers from 'ui-components/lib/helpers/graphql'
import { ChipStatusVariants, Loading, PurchaseBNZ } from '../../../components'
import { chatQueries } from '../../../graphql/queries'
import { chatMutations } from '../../../graphql/mutations'
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'
import { FaPaperclip, FaPaperPlane } from 'react-icons/fa'
import RefuseModal from '../../../components/Modal/Proposals/RefuseModal'
import AcceptModal from '../../../components/Modal/Proposals/AcceptModal'
import ConfirmationModal from '../../../components/Modal/ConfirmationModal'
import RatingModal from '../../../components/Modal/RatingModal'
import { FaCheckCircle, FaExclamationCircle, FaFileSignature, FaChevronRight, FaCalendarAlt, FaUser, FaExpand, FaCompress } from 'react-icons/fa'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Dropzone from '../../../components/Dropzone'
import './DemandDetailsV4.css'
import IconButton from '@mui/material/IconButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faUpload, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import alertify from "alertifyjs"
import "alertifyjs/build/css/alertify.css"
import "alertifyjs/build/css/themes/default.css"
import { useTheme } from '../../../contexts/ThemeContext'
import { getLastLawyerChatAttachment } from '../../../utils/revisia'

alertify.set("notifier", "position", "top-right")

const openDemandAnswerFile = (file) => {
  if (file?.fileURL) {
    window.open(file.fileURL, '_blank', 'noopener,noreferrer')
  }
}

const DemandAnswerFiles = ({ documents }) => {
  if (!documents?.length) return null

  return (
    <div className="demand-answer-files mt-1 d-flex flex-column gap-1">
      {documents.map((file, fileIndex) => (
        <button
          key={file._id || file.fileName || fileIndex}
          type="button"
          className="btn btn-link btn-sm p-0 text-start demand-answer-file"
          onClick={() => openDemandAnswerFile(file)}
        >
          <FaPaperclip style={{ marginRight: '4px' }} />
          {file.name || 'Arquivo'}
        </button>
      ))}
    </div>
  )
}

const DemandDetailsV4 = () => {
  const history = useHistory()
  const { isDark } = useTheme()
  const location = useLocation()
  const { id } = useParams()
  const { push } = useHistory()
  const timestampToDate = require('timestamp-to-date')
  const [isChatExpanded, setIsChatExpanded] = useState(false)
  const [isProposal, setIsProposal] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [acceptDemandBidId, setAcceptDemandBidId] = useState('')
  const [refuseDemandBidId, setRefuseDemandBidId] = useState('')
  const [demandId, setDemandId] = useState('')
  const [modalType, setModalType] = useState('')
  const [openRefuseModal, setOpenRefuseModal] = useState(false)
  const [openAcceptModal, setOpenAcceptModal] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [servicePrice, setServicePrice] = useState('')
  const [clientSubscription, setClientSubscription] = useState('')
  const [documentPending, setDocumentsPending] = useState([])
  const [documentWaiting, setDocumentsWaiting] = useState([])
  const [documentDone, setDocumentsDone] = useState([])
  const [documentPendingApprove, setDocumentPendingApprove] = useState([])
  const [documentsSending, setDocumentsSending] = useState([])
  const [requests, setRequests] = useState([])
  const [showAllStatus, setShowAllStatus] = useState(false)
  const [statusList, setStatusList] = useState([])
  const [showRating, setShowRating] = useState(false)
  const [chatMessage, setChatMessage] = useState('')
  const [chatFiles, setChatFiles] = useState([])
  const [chatLoadingFiles, setChatLoadingFiles] = useState(false)
  const chatMessagesRef = React.useRef(null)

  const { showMessage } = useAlertStack()

  useEffect(() => {
    if (location.search.slice(1) === 'proposal') setIsProposal(true)
  }, [location])

  const { loading: chatLoading, data: chatData, refetch: chatRefetch } = useQuery(chatQueries.GET_CHAT_MESSAGES, {
    variables: {
      demandId: id,
      subscription: ''
    },
    skip: !id
  })

  const [sendChatMessage, { loading: sendChatMessageLoading }] = useMutation(chatMutations.SEND_CHAT_MESSAGES, {
    onCompleted() {
      setChatMessage('')
      setChatFiles([])
      chatRefetch()
    },
    onError() {
      showMessage({
        title: 'Erro ao enviar a mensagem',
        message: 'Tente novamente mais tarde.',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
    },
  })

  const [createRevisiaSignatureIntent, { loading: revisiaSignatureLoading }] = useMutation(
    demandsMutations.CREATE_REVISIA_SIGNATURE_INTENT,
    {
      onCompleted(data) {
        const redirectUrl = data?.createRevisiaSignatureIntent?.redirectUrl
        if (redirectUrl) {
          window.open(redirectUrl, '_blank', 'noopener,noreferrer')
        } else {
          toast.error('Não foi possível abrir a Revisia para assinatura.', { theme: 'dark' })
        }
      },
      onError(error) {
        const message =
          error?.graphQLErrors?.[0]?.message ||
          'Não foi possível preparar o documento para assinatura. Verifique se há anexo do advogado no chat.'
        toast.error(message, { theme: 'dark' })
      },
    }
  )

  const lastLawyerAttachment = getLastLawyerChatAttachment(chatData?.getChatMessages)
  const canSignWithRevisia = Boolean(lastLawyerAttachment)

  const handleSignWithRevisia = () => {
    if (!canSignWithRevisia) {
      toast.error('Nenhum anexo PDF/DOC/DOCX do advogado encontrado no chat.', { theme: 'dark' })
      return
    }

    createRevisiaSignatureIntent({
      variables: {
        demandId: id,
      },
    })
  }

  const canSendChatMessage = chatMessage.trim().length > 0 || chatFiles.length > 0

  const handleChatSendMessage = () => {
    if (canSendChatMessage) {
      sendChatMessage({
        variables: {
          demandId: id,
          lawyerId: demandData?.demand?.lawyer?._id || null,
          message: chatMessage,
          subscription: clientSubscription,
          files: chatFiles
        }
      })
    }
  }

  const handleChatMessageKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      if (canSendChatMessage) {
        handleChatSendMessage()
      }
    }
  }

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight
    }
  }, [chatData])

  const formatChatTime = (timestamp) => {
    const date = new Date(timestamp)
    const hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    return `${hours}:${minutes}`
  }


  const handleChatFiles = (file) => {
    setChatLoadingFiles(false)
    const actualFilesList = file.map(({ fileName: name, randomFileName, mimeType, fileExtension: extension, fileSize: size }) => ({
      attachment: '',
      name,
      randomFileName,
      mimeType,
      extension,
      size,
    }))
    setChatFiles(actualFilesList)
  }

  const { data: dataBonuzSubscription } = useQuery(walletQueries.GET_MY_SUBSCRIPTION, {
    variables: {
      subscriptionType: 'planos-bonuz',
      planIdentifier: 'bonuz-plans',
    },
  })

  const { loading: demandLoading, data: demandData } = useQuery(demandsQueries.GET_DEMAND, {
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  })

  const { refetch: refetchDemands } = useQuery(demandsQueries.GET_DEMANDS, {
    variables: {
      queryBy: 'status',
      query: 'in_estimating',
    },
  })

  const { data: walletData, refetch: refetchMyWallet } = useQuery(walletQueries.GET_MY_WALLET)

  useQuery(demandsQueries.GET_DEMAND_REQUESTS, {
    variables: {
      id,
    },
    onCompleted(response) {
      setRequests(response.getRequest)
    }
  })

  useEffect(() => {
    const items = requests?.filter((item) => item.status !== 'refused')
    setDocumentsPending(
      items
        ?.flatMap((item) => item.documents.map((reg) => ({ ...reg, requestStatus: item.status, requestDebitBNZ: item.debitBNZ, demandId: item.demandId })))
        .filter((item) => ['pending', 'refused'].includes(item.status))
    )
    setDocumentsWaiting(
      items
        ?.flatMap((item) => item.documents.map((reg) => ({ ...reg, requestStatus: item.status, requestDebitBNZ: item.debitBNZ, demandId: item.demandId })))
        .filter((item) => item.status === 'waiting_lawyer_acceptance')
    )
    setDocumentsDone(
      items
        ?.flatMap((item) => item.documents.map((reg) => ({ ...reg, requestStatus: item.status, requestDebitBNZ: item.debitBNZ, demandId: item.demandId })))
        .filter((item) => item.status === 'done')
    )
    const documents = items?.filter((item) => item.status === 'pending' && item.debitBNZ)
    let pendingApprove = null
    if (documents?.length > 0) {
      pendingApprove = documents[0]
    }
    setDocumentPendingApprove(pendingApprove)
  }, [requests])

  const [reproveDemandBid, { loading: reproveDemandBidLoading }] = useMutation(demandsMutations.REPROVE_DEMAND_BID, {
    variables: {
      bidId: refuseDemandBidId,
    },
    onCompleted() {
      setOpenRefuseModal(false)
      refetchDemands()
      push('/dashboard/serviços/propostas')
    },
    update: graphqlHelpers.deleteItemsFromCache('Demands'),
    onError() {
      setOpenRefuseModal(false)
      toast.error('Erro ao reprovar a proposta, tente novamente mais tarde', {
        theme: 'dark'
      })
    },
  })

  const [approveDemandBid, { loading: approveDemandBidLoading }] = useMutation(demandsMutations.APPROVE_DEMAND_BID, {
    variables: {
      bidId: acceptDemandBidId,
    },
    onCompleted() {
      setOpenAcceptModal(false)
      refetchDemands()
      push('/dashboard/serviços/propostas')
    },
    update: graphqlHelpers.deleteItemsFromCache('Demands'),
    onError() {
      setOpenAcceptModal(false)
      toast.error('Erro ao aceitar a proposta, tente novamente mais tarde', {
        theme: 'dark'
      })
    },
  })

  const [approveRequest, { loading: loadingApproveRequest }] = useMutation(demandsMutations.APPROVE_REQUEST, {
    onCompleted() {
      toast.success('Sua aprovação foi enviada com sucesso.', {
        theme: 'dark'
      })
    },
    onError({ graphQLErrors }){
      toast.error(graphQLErrors[0].extensions.response.body.message || 'tente novamente novamente mais tarde', {
        theme: 'dark'
      })
    }
  })

  const [refuseRequest, { loading: loadingRefuseRequest }] = useMutation(demandsMutations.REFUSE_REQUEST, {
    onCompleted() {
      toast.success('Sua recusa foi enviada com sucesso.', {
        theme: 'dark'
      })
    },
    onError({ graphQLErrors }){
      toast.error(graphQLErrors[0].extensions.response.body || 'tente novamente novamente mais tarde', {
        theme: 'dark'
      })
    }
  })

  const handleRefuseRequest = async (request) => {
    alertify.confirm('Confirmação', 'Deseja realmente recusar a solicitação de documentos?', async () => {
      try {
        await refuseRequest({
          variables: {
            demandId: request.demandId,
            requestId: request._id
          }
        })
        const updatedRequests = requests.map(item => {
          if (item._id === request._id) {
            item.status = 'refused'
          }
          return item
        })
        setRequests(updatedRequests)
      } catch (error) {
      }
    }, null).set({labels:{ok:'Sim', cancel: 'Não'}})
  }

  const handleApproveRequest = async (request) => {
    alertify.confirm('Confirmação', 'Deseja realmente aprovar a solicitação de documentos?', async () => {
      try {
        const approve = await approveRequest({
          variables: {
            demandId: request.demandId,
            requestId: request._id
          }
        })
        if (approve) {
          const updatedRequests = requests.map(item => {
            if (item._id === request._id) {
              item.status = 'approved'
            }
            return item
          })
          setRequests(updatedRequests)
        }
      } catch (error) {
      }
    }, null).set({labels:{ok:'Sim', cancel: 'Não'}})
  }

  const handleRefuseDemandBid = useCallback(() => {
    reproveDemandBid()
  }, [reproveDemandBid])

  const handleAcceptDemandBid = useCallback(() => {
    approveDemandBid()
  }, [approveDemandBid])

  const handleOpenAcceptModal = useCallback((bidId) => {
    setAcceptDemandBidId(bidId)
    setOpenAcceptModal(prev => !prev)
  }, [])

  const handleOpenRefuseModal = useCallback((bidId) => {
    setRefuseDemandBidId(bidId)
    setOpenRefuseModal(prev => !prev)
  }, [])

  const handleConfirmationModal = useCallback((type) => {
    setDemandId(id)
    setModalType(type)
    setOpenConfirmationModal(prev => !prev)
  }, [id])

  const openModal = useCallback((price) => {
    setServicePrice(price)
    setModalIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setModalIsOpen(false)
    refetchMyWallet()
  }, [refetchMyWallet])

  useEffect(() => {
    const id = dataBonuzSubscription?.subscription?.planIdentifier
    setClientSubscription(id && dataBonuzSubscription?.subscription?.active ? id : '')
  }, [dataBonuzSubscription])

  const [sendFileRequestDocument] = useMutation(demandsMutations.SEND_FILE_REQUEST_DOCUMENT, {
    onCompleted() {
      toast.success('Seu arquivo foi enviada com sucesso.', {
        theme: 'dark'
      })
    },
    onError() {
      toast.error('Houve um erro ao tentar enviar seu arquivo. Tente novamente', {
        theme: 'dark'
      })
    },
  })

  const setUploadDocument = async (document, isLoading) => {
    if (isLoading) {
      setDocumentsSending((prevDocuments) => [...prevDocuments, document._id])
    }
  }

  const setFilesHandler = async (sendFiles, document) => {
    const variables = {
      demandId: document?.demandId,
      requestId: document?.requestId,
      documentId: document?._id,
      files: sendFiles.map(({ fileName: name, randomFileName, mimeType, fileExtension: extension, fileSize: size }) => ({
        attachment: '',
        name,
        randomFileName,
        mimeType,
        extension,
        size,
      }))
    }
    try {
      const { data: { sendFileRequestDocument: { files } } = {} } = await sendFileRequestDocument({
        variables
      })
      document.status = 'waiting_lawyer_acceptance'
      document.filesDelivery = files

      const updatedRequests = requests.map(request => {
        request.documents = request.documents.map(item => item._id === document._id ? document : item)
        return request
      })
      setRequests(updatedRequests)
    } catch (error) {
    } finally {
      setDocumentsSending((prevDocuments) => prevDocuments.filter((item) => item !== document._id))
    }
  }

  const handleCloseRatingModal = () => {
    setShowRating(false)
    push('/dashboard/serviços')
  }

  useEffect(() => {
    let itens = demandData?.demand?.demandInteractionsHistory?.filter(item => item.status)
    if (!showAllStatus && itens && itens.length > 0) {
      itens = itens.slice(0, 5)
    }
    setStatusList(itens)
  }, [showAllStatus, demandData])

  const handleApprove = () => {
    if (demandData?.demand?.status === 'waiting_approval') {
      handleConfirmationModal('concluir')
    } else if (demandData?.demand?.status === 'waiting_estimate_approval') {
      if (walletData?.wallet?.balance >= demandData?.demand?.price) {
        handleConfirmationModal('aceitar')
      } else {
        openModal(demandData?.demand?.price)
      }
    } else if (isProposal && demandData?.demand?.demandBids?.[0]) {
      if (walletData?.wallet?.balance > demandData?.demand?.demandBids[0]?.price) {
        handleOpenAcceptModal(demandData?.demand?.demandBids[0]?._id)
      } else {
        openModal(demandData?.demand?.demandBids[0]?.price)
      }
    }
  }

  const handleRequestChanges = () => {
    if (demandData?.demand?.status === 'waiting_approval') {
      handleConfirmationModal('revisar')
    } else if (demandData?.demand?.status === 'waiting_estimate_approval') {
      handleConfirmationModal('recusar')
    } else if (isProposal && demandData?.demand?.demandBids?.[0]) {
      handleOpenRefuseModal(demandData?.demand?.demandBids[0]?._id)
    }
  }

  if (demandLoading) return <Loading />

  const demand = demandData?.demand

  // Timeline data from demandInteractionsHistory
  const timelineData = statusList?.map((interaction, index) => {
    const statusType = interaction.status === 'done' ? 'completed' : 
                      interaction.status === 'in_progress' ? 'active' :
                      interaction.status === 'waiting_approval' ? 'waiting' : 'pending'
    return {
      date: timestampToDate(interaction.createdAt, 'dd/MM/yyyy'),
      status: <ChipStatusVariants status={interaction.status} noStyle={true} />,
      type: statusType,
    }
  }) || []

  return (
    <>
    <div className="demand-details-v4-container">
      <div className="container-fluid px-4 px-lg-5" style={{ paddingTop: '10px', paddingBottom: '16px' }}>
        {/* Header */}
        <div className="mb-4">
        <div className="d-flex align-items-center gap-2 text-muted small mb-3">
          <span onClick={() => history.push('/dashboard')} style={{ cursor: 'pointer' }}>Início</span>
          <FaChevronRight style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
          <span onClick={() => history.push('/dashboard/serviços')} style={{ cursor: 'pointer' }}>Serviços</span>
          <FaChevronRight style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
          <span onClick={() => history.push('/dashboard/serviços/demands')} style={{ cursor: 'pointer' }}>Demandas</span>
          <FaChevronRight style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
          <span className="fw-medium" style={{color: 'var(--text-color)'}}>Demanda</span>
        </div>
        <h1 className="fs-2 fw-bold demand-details-title mb-2">
          #{String(demand?.code || '').padStart(6, '0')} - {demand?.fullDescription || '-'}
        </h1>
        <p className="text-muted-foreground">{demand?.subserviceDescription || '-'}</p>
      </div>

        {/* Info Cards */}
        <div className="row g-3 mb-4">
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card shadow-elegant transition-smooth h-100">
              <div className="card-body p-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="p-2 bg-primary bg-opacity-10 rounded">
                    <FaCalendarAlt className="text-primary" style={{ width: '20px', height: '20px', color: isDark ? '#FFFFFF' : undefined }} />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Prazo Final</p>
                    <p className="fw-semibold mb-0" style={{color: 'var(--text-color)'}}>
                      {demand?.finalDate ? timestampToDate(demand.finalDate, 'dd/MM/yyyy') : '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card shadow-elegant transition-smooth h-100">
              <div className="card-body p-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="p-2 bg-primary bg-opacity-10 rounded">
                    <FaUser className="text-primary" style={{ width: '20px', height: '20px', color: isDark ? '#FFFFFF' : undefined }} />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Responsável</p>
                    <p className="fw-semibold mb-0" style={{color: 'var(--text-color)'}}>{demand?.lawyer?.displayAs || '-'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card shadow-elegant transition-smooth h-100">
              <div className="card-body p-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="p-2 bg-warning bg-opacity-10 rounded">
                    <FaExclamationCircle className="text-warning" style={{ width: '20px', height: '20px' }} />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Status</p>
                    <span className="badge badge-secondary mt-1">
                      <ChipStatusVariants status={demand?.status} noStyle={true} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div className="card shadow-elegant transition-smooth h-100">
              <div className="card-body p-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="p-2 bg-primary bg-opacity-10 rounded">
                    <FaUser className="text-primary" style={{ width: '20px', height: '20px', color: isDark ? '#FFFFFF' : undefined }} />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Participantes</p>
                    <p className="fw-semibold mb-0" style={{color: 'var(--text-color)'}}>-</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - Actions e Chat */}
        <div className="row g-4 mb-4">
          {/* Actions Column */}
          <div className="col-12 col-lg-5 col-xl-4">
            <div className="card shadow-elegant">
              <div className="card-body p-4">
                <h2 className="fs-5 fw-semibold mb-3">Ações da Demanda</h2>
                <p className="small text-muted-foreground mb-4">
                  Analise a demanda e escolha uma ação para prosseguir com o processo
                </p>

                <div className="row g-3">
                  {(demand?.status === 'waiting_approval' || demand?.status === 'waiting_estimate_approval' || (isProposal && demand?.demandBids?.[0])) && (
                    <>
                      <div className="col-12 col-md-6">
                        <div className="h-100">
                          <button
                            onClick={handleApprove}
                            className="btn btn-success w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-3 py-4 shadow-sm"
                            style={{ minHeight: '140px' }}
                            disabled={
                              (demand?.status === 'waiting_estimate_approval' && walletData?.wallet?.balance < demand?.price) ||
                              (isProposal && walletData?.wallet?.balance <= demand?.demandBids?.[0]?.price)
                            }
                          >
                            <FaCheckCircle style={{ width: '32px', height: '32px' }} />
                            <div className="text-center">
                              <div className="fw-semibold">Aprovar</div>
                              <div className="small" style={{ opacity: 0.9, fontWeight: 'normal' }}>Demanda está OK</div>
                            </div>
                          </button>
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="h-100">
                          <button
                            onClick={handleRequestChanges}
                            className="btn btn-outline-warning w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-3 py-4 shadow-sm"
                            style={{ minHeight: '140px' }}
                          >
                            <FaExclamationCircle style={{ width: '32px', height: '32px' }} />
                            <div className="text-center">
                              <div className="fw-semibold">Solicitar Ajustes</div>
                              <div className="small" style={{ opacity: 0.9, fontWeight: 'normal' }}>Precisa de alterações</div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  
                  <div className="col-12 col-md-6">
                    <div className="h-100">
                      <button
                        onClick={handleSignWithRevisia}
                        disabled={!canSignWithRevisia || revisiaSignatureLoading || chatLoading}
                        title={
                          canSignWithRevisia
                            ? `Enviar ${lastLawyerAttachment.name} para assinatura na Revisia`
                            : 'Aguarde um anexo PDF/DOC/DOCX do advogado no chat'
                        }
                        className="w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-3 py-4 border-0 rounded-3 position-relative overflow-hidden"
                        style={{ 
                          minHeight: '140px',
                          background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)',
                          color: '#ffffff',
                          boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3), 0 2px 8px rgba(139, 92, 246, 0.2)',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          cursor: (!canSignWithRevisia || revisiaSignatureLoading || chatLoading) ? 'not-allowed' : 'pointer',
                          opacity: (!canSignWithRevisia || revisiaSignatureLoading || chatLoading) ? 0.65 : 1
                        }}
                        onMouseEnter={(e) => {
                          if (!canSignWithRevisia || revisiaSignatureLoading || chatLoading) return
                          e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 10px 30px rgba(139, 92, 246, 0.5), 0 6px 15px rgba(139, 92, 246, 0.4)';
                          e.currentTarget.style.background = 'linear-gradient(135deg, #9d6af7 0%, #8c4bf0 50%, #7d3aed 100%)';
                          const icon = e.currentTarget.querySelector('svg');
                          if (icon) {
                            icon.style.transform = 'scale(1.15) rotate(5deg)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0) scale(1)';
                          e.currentTarget.style.boxShadow = '0 4px 15px rgba(139, 92, 246, 0.3), 0 2px 8px rgba(139, 92, 246, 0.2)';
                          e.currentTarget.style.background = 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)';
                          const icon = e.currentTarget.querySelector('svg');
                          if (icon) {
                            icon.style.transform = 'scale(1) rotate(0deg)';
                          }
                        }}
                        onMouseDown={(e) => {
                          if (!canSignWithRevisia || revisiaSignatureLoading || chatLoading) return
                          e.currentTarget.style.transform = 'translateY(-1px) scale(0.98)';
                        }}
                        onMouseUp={(e) => {
                          if (!canSignWithRevisia || revisiaSignatureLoading || chatLoading) return
                          e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
                        }}
                      >
                        <div 
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'radial-gradient(circle at 50% 0%, rgba(255,255,255,0.15) 0%, transparent 60%)',
                            pointerEvents: 'none'
                          }}
                        />
                        <div style={{ position: 'relative', zIndex: 1 }}>
                          {revisiaSignatureLoading ? (
                            <Loading />
                          ) : (
                            <FaFileSignature 
                              style={{ 
                                width: '38px', 
                                height: '38px',
                                filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.25))',
                                transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                              }} 
                            />
                          )}
                        </div>
                        <div className="text-center" style={{ position: 'relative', zIndex: 1 }}>
                          <div className="fw-bold" style={{ fontSize: '1.15rem', letterSpacing: '0.5px', textShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>
                            {revisiaSignatureLoading ? 'Preparando...' : 'Assinar'}
                          </div>
                          <div className="small" style={{ opacity: 0.95, fontWeight: '400', fontSize: '0.9rem', marginTop: '2px' }}>
                            {canSignWithRevisia
                              ? lastLawyerAttachment.name
                              : 'Assinatura eletrônica'}
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          {/* Chat Column */}
          <div className={`col-12 ${isChatExpanded ? 'col-lg-12' : 'col-lg-7 col-xl-8'} transition-smooth`}>
            <div className={`card shadow-elegant d-flex flex-column transition-smooth`} style={{ height: isChatExpanded ? '800px' : '600px' }}>
              {/* Header */}
              <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <div className="p-2 bg-primary bg-opacity-10 rounded">
                    <svg className="text-primary" fill="none" viewBox="0 0 24 24" stroke={isDark ? '#FFFFFF' : 'currentColor'} style={{ width: '20px', height: '20px' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="fw-semibold mb-0" style={{ fontSize: '1rem' }}>Chat da Demanda</h3>
                    <p className="text-muted-foreground mb-0" style={{ fontSize: '0.75rem' }}>Converse com seu advogado</p>
                  </div>
                </div>
                <button
                  className="btn btn-ghost p-2 transition-smooth"
                  onClick={() => setIsChatExpanded(!isChatExpanded)}
                  style={{ width: '40px', height: '40px' }}
                >
                  {isChatExpanded ? (
                    <FaCompress style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
                  ) : (
                    <FaExpand style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
                  )}
                </button>
              </div>

              {/* Messages */}
              <div className="flex-fill p-3 scroll-area" ref={chatMessagesRef} style={{ overflowY: 'auto', maxHeight: 'calc(100% - 120px)' }}>
                {chatLoading ? (
                  <div className="text-center py-4">
                    <Loading />
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    {chatData?.getChatMessages?.map((msg, index) => {
                      const isClient = msg.sender === 'client'
                      return (
                        <div key={msg._id || index} className={`d-flex gap-3 ${isClient ? 'flex-row-reverse' : ''}`}>
                          <div className="avatar">
                            <div className={`avatar-fallback ${isClient ? 'bg-primary text-white' : 'bg-muted'}`}>
                              {isClient ? 'C' : (demand?.lawyer?.displayAs?.charAt(0) || 'A')}
                            </div>
                          </div>
                          <div className={`flex-fill ${isClient ? 'text-end' : ''}`}>
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span className="small fw-medium">{isClient ? 'Cliente' : (demand?.lawyer?.displayAs || 'Advogado')}</span>
                              <span className="text-muted-foreground" style={{ fontSize: '0.75rem' }}>
                                {formatChatTime(msg.createdAt || msg.created_at)}
                              </span>
                            </div>
                            <div
                              className="d-inline-block rounded p-3 small"
                              style={{
                                maxWidth: '85%',
                                backgroundColor: isClient ? 'var(--bs-primary)' : '#f3f4f6',
                                color: isClient ? 'white' : 'var(--bs-body-color)',
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                              }}
                            >
                              {msg.message}
                              {msg.files && msg.files.length > 0 && msg.files.map((file, fileIndex) => (
                                <div key={fileIndex} className="mt-2">
                                  <button
                                    type="button"
                                    className={`btn btn-sm btn-link p-0 ${isClient ? 'text-white' : ''}`}
                                    onClick={() => window.open(file.fileURL, '_blank')}
                                    style={{ 
                                      textDecoration: 'underline',
                                      color: isClient ? 'white' : 'var(--text-color)'
                                    }}
                                  >
                                    <FaPaperclip style={{ marginRight: '4px' }} />
                                    {file.name}
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    {(!chatData?.getChatMessages || chatData.getChatMessages.length === 0) && (
                      <div className="text-center text-muted py-4">
                        <p className="mb-2"><strong>Envie mensagens, anexos e mídias</strong></p>
                        <p className="small">Nenhuma mensagem ainda</p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Input */}
              <div className="p-3 border-top">
                <div className="d-flex gap-2 align-items-end">
                  <button
                    className="btn btn-ghost p-2"
                    style={{ width: '40px', height: '40px' }}
                    onClick={(e) => {
                      e.preventDefault()
                      const fileHandler = document.getElementById('chat-file-demand')
                      if (fileHandler) fileHandler.click()
                    }}
                  >
                    <FaPaperclip style={{ width: '16px', height: '16px', color: isDark ? '#FFFFFF' : undefined }} />
                  </button>
                  <textarea
                    className="form-control flex-fill"
                    rows={1}
                    value={chatMessage}
                    onChange={(e) => setChatMessage(e.target.value)}
                    placeholder="Escreva uma mensagem..."
                    onKeyDown={handleChatMessageKeyDown}
                    disabled={sendChatMessageLoading || chatLoadingFiles}
                    style={{ minHeight: '38px', maxHeight: '120px', resize: 'none' }}
                  />
                  <button
                    onClick={handleChatSendMessage}
                    className="btn btn-primary"
                    style={{ width: '40px', height: '40px' }}
                    disabled={sendChatMessageLoading || chatLoadingFiles || !canSendChatMessage}
                  >
                    {sendChatMessageLoading || chatLoadingFiles ? (
                      <Loading />
                    ) : (
                      <FaPaperPlane style={{ width: '16px', height: '16px' }} />
                    )}
                  </button>
                </div>
                {chatFiles.length > 0 && (
                  <div className="mt-2 d-flex gap-2 flex-wrap">
                    {chatFiles.map((file, index) => (
                      <span key={index} className="badge bg-secondary">
                        {file.name}
                      </span>
                    ))}
                  </div>
                )}
                <Dropzone
                  onLoad={setChatLoadingFiles}
                  onComplete={(file) => handleChatFiles(file)}
                  id="chat-file-demand"
                  classe="dropzone-hide"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Secondary Content - Info Below */}
        <div className="row g-4">
          {/* Demand Information */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="card shadow-elegant h-100">
              <div className="card-body p-4">
                <h2 className="fs-5 fw-semibold mb-3">Informações da Demanda</h2>
                <div className="mb-3">
                  <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Descrição</p>
                  <p className="small mb-0" style={{color: 'var(--text-color)'}}>
                    {demand?.fullDescription || '-'}
                  </p>
                </div>
                {demand?.demandInteractionsHistory?.[0]?.comment &&
                  !/demanda criada\s*\|\s*planos bonuz/i.test(demand.demandInteractionsHistory[0].comment) && (
                  <div>
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Observações</p>
                    <p className="small mb-0" style={{color: 'var(--text-color)'}}>
                      {demand.demandInteractionsHistory[0].comment}
                    </p>
                  </div>
                )}
                {demand?.demandAnswers?.length > 0 && (
                  <div className="mt-3">
                    <p className="text-muted-foreground mb-1" style={{ fontSize: '0.75rem' }}>Detalhes da demanda</p>
                    {demand.demandAnswers.map((answer, counter) => (
                      <div key={answer._id || counter} className="mb-2">
                        <p className="small mb-1">
                          <b>{answer.description}</b>
                        </p>
                        {answer.answer ? (
                          <p className="small mb-0" style={{color: 'var(--text-color)'}}>
                            Resposta: <b>{answer.answer}</b>
                          </p>
                        ) : null}
                        <DemandAnswerFiles documents={answer.documents} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Document Requests */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="card shadow-elegant h-100">
              <div className="card-body p-4">
                <h2 className="fs-5 fw-semibold mb-3">Documentos Solicitados</h2>
                <div className="d-flex flex-column gap-3">
                  {documentPendingApprove && (
                    <div className="p-3 bg-warning bg-opacity-10 rounded mb-2">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="small fw-medium">Débito adicional</span>
                        <span className="badge bg-warning">{documentPendingApprove.valueBNZ} BNZs</span>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm"
                          style={{ backgroundColor: '#9997A0', color: '#FFFFFF', flex: 1 }}
                          onClick={() => handleRefuseRequest(documentPendingApprove)}
                          disabled={loadingRefuseRequest || loadingApproveRequest}
                        >
                          {loadingRefuseRequest || loadingApproveRequest ? '...' : 'Recusar'}
                        </button>
                        <button
                          className="btn btn-sm btn-success"
                          style={{ flex: 1 }}
                          onClick={() => handleApproveRequest(documentPendingApprove)}
                          disabled={loadingRefuseRequest || loadingApproveRequest}
                        >
                          {loadingRefuseRequest || loadingApproveRequest ? '...' : 'Aprovar'}
                        </button>
                      </div>
                    </div>
                  )}
                  
                  {documentDone.map((item) => (
                    <div key={item._id} className="d-flex align-items-center justify-content-between p-3 rounded border">
                      <div className="d-flex align-items-center gap-3 flex-fill">
                        <div className="p-2 bg-success bg-opacity-10 rounded">
                          <FaFileSignature className="text-success" style={{ width: '16px', height: '16px', color: isDark ? '#44E47A' : undefined }} />
                        </div>
                        <div className="flex-fill">
                          <p className="small fw-medium mb-0">{item.description}</p>
                          <p className="text-muted-foreground mb-0" style={{ fontSize: '0.75rem' }}>
                            {item.filesDelivery?.[0]?.createdAt ? `Enviado em ${timestampToDate(item.filesDelivery[0].createdAt, 'dd/MM/yyyy')}` : 'Enviado'}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {item.filesRequest?.length > 0 && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Baixar modelo</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => window.open(item.filesRequest[0].fileURL, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} color="#44E47A" />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        {item?.filesDelivery && item?.filesDelivery?.length > 0 && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Baixar documento enviado</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => window.open(item.filesDelivery[0].fileURL, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} color="#44E47A" />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        <span className="badge bg-success bg-opacity-10 text-success">Enviado</span>
                      </div>
                    </div>
                  ))}

                  {documentPending.map((item) => (
                    <div key={item._id} className={`d-flex align-items-center justify-content-between p-3 rounded border ${item.status === 'refused' ? 'border-danger' : ''}`}>
                      <div className="d-flex align-items-center gap-3 flex-fill">
                        <div className={`p-2 rounded ${item.status === 'refused' ? 'bg-danger bg-opacity-10' : 'bg-warning bg-opacity-10'}`}>
                          <FaFileSignature className={item.status === 'refused' ? 'text-danger' : 'text-warning'} style={{ width: '16px', height: '16px', color: isDark ? (item.status === 'refused' ? '#F14F5C' : '#F8AE3F') : undefined }} />
                        </div>
                        <div className="flex-fill">
                          <p className="small fw-medium mb-0">{item.description}</p>
                          <p className="text-muted-foreground mb-0" style={{ fontSize: '0.75rem' }}>
                            {item.filesRequest?.[0]?.createdAt ? `Prazo: ${timestampToDate(item.filesRequest[0].createdAt, 'dd/MM/yyyy')}` : 'Pendente'}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {!documentPendingApprove && item.status === 'refused' && item.comment && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>{item.comment}</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton size="small">
                              <FontAwesomeIcon icon={faInfoCircle} color="#F14F5C" />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        {item.filesRequest?.length > 0 && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Baixar modelo</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => window.open(item.filesRequest[0].fileURL, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} color={item.status === 'refused' ? '#F14F5C' : (isDark ? '#FFFFFF' : null)} />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        {!documentPendingApprove && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Enviar documento</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.preventDefault()
                                let fileHandler = document.getElementById(item._id)
                                if (fileHandler) {
                                  fileHandler.click()
                                }
                              }}
                              disabled={
                                (documentsSending && documentsSending?.includes(item._id)) ||
                                (item.requestDebitBNZ && item.requestStatus === 'pending')
                              }
                            >
                              {documentsSending && documentsSending?.includes(item._id) ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              ) : (
                                <FontAwesomeIcon icon={faUpload} color={item.status === 'refused' ? '#F14F5C' : (isDark ? '#FFFFFF' : null)} />
                              )}
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        <Dropzone
                          multiple={false}
                          onLoad={(isLoading) => setUploadDocument(item, isLoading)}
                          id={item._id}
                          onComplete={(file) => setFilesHandler(file, item)}
                          classe="dropzone-hide"
                        />
                        <span className={`badge ${item.status === 'refused' ? 'bg-danger bg-opacity-10 text-danger' : 'bg-warning bg-opacity-10 text-warning'}`}>
                          {item.status === 'refused' ? 'Recusado' : 'Pendente'}
                        </span>
                      </div>
                    </div>
                  ))}

                  {documentWaiting.map((item) => (
                    <div key={item._id} className="d-flex align-items-center justify-content-between p-3 rounded border">
                      <div className="d-flex align-items-center gap-3 flex-fill">
                        <div className="p-2 bg-warning bg-opacity-10 rounded">
                          <FaFileSignature className="text-warning" style={{ width: '16px', height: '16px', color: isDark ? '#F8AE3F' : undefined }} />
                        </div>
                        <div className="flex-fill">
                          <p className="small fw-medium mb-0">{item.description}</p>
                          <p className="text-muted-foreground mb-0" style={{ fontSize: '0.75rem' }}>Aguardando aprovação</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {item.filesRequest?.length > 0 && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Baixar modelo</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => window.open(item.filesRequest[0].fileURL, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} color="#F8AE3F" />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        {item?.filesDelivery && item?.filesDelivery?.length > 0 && (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={
                              <Popover>
                                <Popover.Body>Baixar documento enviado</Popover.Body>
                              </Popover>
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() => window.open(item.filesDelivery[0].fileURL, '_blank')}
                            >
                              <FontAwesomeIcon icon={faDownload} color="#F8AE3F" />
                            </IconButton>
                          </OverlayTrigger>
                        )}
                        <span className="badge bg-warning bg-opacity-10 text-warning">Aguardando</span>
                      </div>
                    </div>
                  ))}

                  {documentPending.length === 0 && documentWaiting.length === 0 && documentDone.length === 0 && !documentPendingApprove && (
                    <div className="text-center text-muted py-4">Nenhuma solicitação encontrada</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Timeline */}
          <div className="col-12 col-lg-4">
            <div className="card shadow-elegant d-flex flex-column" style={{ height: '600px', maxHeight: '600px' }}>
              <div className="card-body p-3 d-flex flex-column" style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <h2 className="small fw-semibold mb-3" style={{ flexShrink: 0 }}>Linha do Tempo</h2>
                <div className="position-relative flex-fill" style={{ overflowY: 'auto', minHeight: 0, flex: 1 }}>
                  {timelineData.length > 0 ? (
                    timelineData.map((item, index) => {
                      const isLast = index === timelineData.length - 1
                      const getStatusColor = (type) => {
                        switch (type) {
                          case "completed":
                            return { text: "text-success", bg: "bg-success bg-opacity-10" }
                          case "active":
                            return { text: "text-primary", bg: "bg-primary bg-opacity-10" }
                          case "waiting":
                            return { text: "text-warning", bg: "bg-warning bg-opacity-10" }
                          case "pending":
                            return { text: "text-muted", bg: "bg-muted" }
                          default:
                            return { text: "text-muted", bg: "bg-muted" }
                        }
                      }
                      const colors = getStatusColor(item.type)
                      const Icon = item.type === 'completed' ? FaCheckCircle : item.type === 'active' ? FaExclamationCircle : FaExclamationCircle

                      return (
                        <div
                          key={index}
                          className={`position-relative d-flex gap-3 ${index !== 0 ? 'mt-4' : ''}`}
                        >
                          {!isLast && (
                            <div
                              className={`position-absolute ${item.type === 'completed' || item.type === 'active' ? 'bg-success' : 'border-secondary'}`}
                              style={{
                                left: '20px',
                                top: '48px',
                                width: '2px',
                                height: 'calc(100% + 16px)'
                              }}
                            />
                          )}
                          <div
                            className={`position-relative d-flex align-items-center justify-content-center rounded-circle ${colors.bg} ${colors.text}`}
                            style={{
                              width: '40px',
                              height: '40px',
                              flexShrink: 0,
                              zIndex: 10
                            }}
                          >
                            <Icon style={{ width: '20px', height: '20px', color: isDark ? '#FFFFFF' : undefined }} />
                          </div>
                          <div className="flex-fill pt-1">
                            <div className="d-flex align-items-center gap-3 mb-1">
                              <span className={`badge ${item.type === "completed" ? "bg-success" : "badge-secondary"}`}>
                                {item.status}
                              </span>
                              <span className="small text-muted-foreground">{item.date}</span>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div className="text-center text-muted py-4">Nenhum movimento encontrado</div>
                  )}
                  {demandData?.demand?.demandInteractionsHistory?.filter(item => item.status)?.length > 5 && (
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-link btn-sm"
                        onClick={() => setShowAllStatus(!showAllStatus)}
                      >
                        ver {showAllStatus ? 'menos' : 'mais'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    {/* Modals */}
    <AcceptModal
        openModal={openAcceptModal}
        handleClose={() => setOpenAcceptModal(false)}
        action={handleAcceptDemandBid}
        loading={approveDemandBidLoading}
      />
      <RefuseModal
        openModal={openRefuseModal}
        handleClose={() => setOpenRefuseModal(false)}
        action={handleRefuseDemandBid}
        loading={reproveDemandBidLoading}
      />
      <Modal
        open={modalIsOpen}
        onClose={() => {
          closeModal()
        }}
        disableAutoFocus
        sx={{ zIndex: '9999' }}
      >
        <PurchaseBNZ
          closeParentModal={() => {
            closeModal()
          }}
          servicePrice={servicePrice}
        />
      </Modal>
      <ConfirmationModal
        openModal={openConfirmationModal}
        handleClose={() => setOpenConfirmationModal(false)}
        type={modalType}
        id={demandId}
        openRating={() => { setShowRating(true) }}
      />
      <RatingModal
        openModal={showRating}
        handleClose={() => handleCloseRatingModal()}
        demandId={id}
        lawyerId={demand?.lawyer?._id}
        lawyerName={demand?.lawyer?.displayAs}
      />
    </>
  )
}

export { DemandAnswerFiles }
export default DemandDetailsV4

